import React, { useState } from "react";
import axios from "axios";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import Constant from "../Constant";

const EditSubscriptionModal = ({
  open,
  onClose,
  subscription,
  onSubscriptionUpdated,
  showNotification,
}) => {
  const [formData, setFormData] = useState({
    validThrough: new Date(subscription.validThrough)
      .toISOString()
      .split("T")[0],
    isActive: subscription.isActive,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await axios.put(
        `${Constant.apiBasePath}subscriptions/${subscription._id}`,
        formData
      );
      showNotification("Subscription updated successfully");
      onSubscriptionUpdated();
      onClose();
    } catch (error) {
      if (error.response && error.response.data) {
        showNotification(error.response.data.message, "error");
      } else {
        showNotification("Failed to update subscription", "error");
      }
      console.error("Error updating subscription:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Popup
      open={open}
      onClose={onClose}
      contentStyle={{ maxWidth: "600px", width: "80%" }}
      modal
      nested
    >
      <div className="popup-container">
        <h2>Edit Subscription</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group mb-3">
            <label className="form-label">User: </label>
            <span>{subscription.userId?.name || "N/A"}</span>
          </div>

          <div className="form-group mb-3">
            <label className="form-label">Plan Type: </label>
            <span>{subscription.planType}</span>
          </div>

          <div className="form-group mb-3">
            <label className="form-label">Valid Through:</label>
            <input
              type="date"
              className="form-control"
              name="validThrough"
              value={formData.validThrough}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-check mb-3">
            <input
              type="checkbox"
              className="form-check-input"
              id="isActive"
              name="isActive"
              checked={formData.isActive}
              onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="isActive">
              Active
            </label>
          </div>

          <div className="features-group mb-3">
            <label className="form-label">Features:</label>
            <ul className="list-unstyled">
              {subscription.planFeatures
                .filter((feature) => feature.enabled === true)
                .map((feature) => (
                  <li key={feature.feature.name}>{feature.feature.name}</li>
                ))}
            </ul>
            <p className="text-muted mt-2">
              <small>
                Note: Features are determined by the selected plan type.
              </small>
            </p>
          </div>

          <div className="button-group">
            <button
              type="submit"
              className="btn btn-primary me-2"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Updating..." : "Update"}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </Popup>
  );
};

export default EditSubscriptionModal;
